import React from 'react'
import MUICircularProgress from "@mui/material/CircularProgress"
export const CircularProgress = () => {
  return (
    <MUICircularProgress size="20px" color='primary'/>
  )
}

